import { CUSTOMERS_SUCCESSFUL_FETCH, CUSTOMERS_SUCCESSFUL_SAVE } from 'reducers/constants';
import {AFILLIATE_SUCCESSFUL_FETCH} from "../constants";

const initialState = {
    items: [],
    item: {}
}

export default function (state = initialState, action) {
    switch (action.type) {
        case AFILLIATE_SUCCESSFUL_FETCH:
            return {
                ...state,
                items: action.payload.slice()
            }
        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/affiliate/affiliateReducer.js